import { Button, Dialog, DialogTitle, Grid, makeStyles, Typography } from "@material-ui/core";
import WhaleLogo from "../../assets/images/whales.png";
import Background from "../../assets/images/stakingRewardsBg.png";

interface WhaleMaxTierProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}




const useStyles = makeStyles((theme) => ({
  root:{
    width: "377px",
    maxWidth: "100%",
    backgroundImage: `url(${Background})`,
    padding: "1.625rem",
    borderRadius: "0.75rem",
    [theme.breakpoints.down("sm")]:{
      width:"100%",
      minWidth:"auto",
    },
  },
  title:{
    fontSize: "1.5rem",
    fontWeight: 700,
    lineHeight: "1.25rem",
  },
  img:{
    margin:"2.5rem 0",
    width:"10.75rem",
    maxWidth:"90%",
  },
  text:{
    color:"rgba(17, 48, 45, 0.5)",
    fontSize:"1rem",
    fontWeight: 400,
    marginTop:"1.5rem",
    textAlign:"center",
  },
  closeBtn:{
   marginTop:"3rem",
   maxWidth:"377px",
   width:"100%",
   height:"2.9rem",
  }
}));
  

export default function WhaleMaxTier({open, setOpen}:WhaleMaxTierProps){

  const classes = useStyles();

  return(
    <Dialog
     open={open}
     disableEscapeKeyDown={false}
     onClose={() => setOpen(false)}
     classes={{paper: classes.root}}
      >
        <DialogTitle style={{padding:0}}>
          
        <Grid 
          container
          item
          >
          <Typography className={classes.title} color="secondary">
            Whale
          </Typography>
          
        </Grid>
        <Grid
        container
        item
        justifyContent="center"
        >
        <img src={WhaleLogo} alt="wizard" className={classes.img} />
        </Grid>
        <Grid
         container
         item
         justifyContent="center">
         <Typography
         className={classes.title}
         style={{fontSize:"2.25rem"}}>
           Max Tier
         </Typography>
        </Grid>
        <Grid>
          <Typography className={classes.text}>
          You have the max tier. You are eligible 
          to participate in the best projects.
          </Typography>
        </Grid>
        <Grid
        container
        item
        justifyContent="center"
        >
          <Button
            variant="contained"
            color="secondary"
            size="small"
            className={classes.closeBtn}
            onClick={()=>setOpen(false)}
           >
            Close
          </Button>
        </Grid>

    </DialogTitle>

    </Dialog>
  )
}